module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kBGSZ"))).then(() => parcelRequire('dJXJK'));